var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuports24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f58220;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.4,33.3h-2.4c-.2,3.7-3.3,6.6-7,6.6s-6.8-2.9-7-6.6h-2.4c-6.5,0-11.7,5.3-11.7,11.7v1.6c0,.8.6,1.4,1.4,1.4h39.4c.8,0,1.4-.6,1.4-1.4v-1.6c0-6.5-5.3-11.7-11.7-11.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.8,21.1v-5.6c-1.6,0-2.8,1.3-2.8,2.8s1.3,2.8,2.8,2.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.7,9.3c.5-.5,1.3-.6,1.9-.1l4.3,3.4h2.3v-.5c0-6.7-5.5-12.2-12.2-12.2s-12.2,5.5-12.2,12.2v.5h7.8c3,0,5.9-1.2,8.1-3.3h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.8,32.1v.8c0,2.3,1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2v-.8c-1.3.5-2.7.8-4.2.8s-2.9-.3-4.2-.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.5,25.8c0-.8.6-1.4,1.4-1.4h7.7c.5-1.1.8-2.4.8-3.8v-4.8l-4.6-3.7c-2.6,2.1-5.7,3.3-9.1,3.3h-5v5.2c0,5.2,4.2,9.4,9.4,9.4s5-1.1,6.7-2.8h-5.8c-.8,0-1.4-.6-1.4-1.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.2,21.1h1.4v.9c0,1.3-1.1,2.3-2.3,2.3h-2.7c-.5,1.1-1.1,2-1.9,2.8h4.6c2.8,0,5.2-2.3,5.2-5.2v-3.8c0-1.6-1.3-2.8-2.8-2.8h-1.4v5.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuports24);
export default __webpack_public_path__ + "static/media/suports24.0d56c5ec11cf5917d105c03b8f532cbe.svg";
export { ForwardRef as ReactComponent };